import { Form } from "antd";

import type { AutocompleteFieldAttributes, FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { Autocomplete } from "../index";

export const AutocompleteField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const attributes = field.attributes as AutocompleteFieldAttributes;

    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <Autocomplete
                displayValue={attributes.displayValue}
                datasource={attributes.datasource}
                key={field.name}
                label={field.translationKeys.label}
                readOnly={readOnly}
            />
        </Form.Item>
    );
};
